/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Display_Scan_To_PayInputs */

const vi_customer_display_scan_to_pay = /** @type {(inputs: Customer_Display_Scan_To_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét mã để thanh toán`)
};

/**

* @param {Customer_Display_Scan_To_PayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_display_scan_to_pay = /** @type {((inputs?: Customer_Display_Scan_To_PayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Display_Scan_To_PayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_display_scan_to_pay(inputs)
});